module.exports = __webpack_public_path__ + "static/media/right.e53e9cdc.svg";